import React, { useState } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { Snackbar, Alert } from '@mui/material';
import ContentDeliveryCalendar from './components/calendar/ContentDeliveryCalendar';

const DeliveryCalendarPage = () => {
    const { tenancyId, deliveryGroupId } = useParams();
    const location = useLocation();
    const navigate = useNavigate();

    // Notification state
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'success'
    });

    // Define the notification function
    const showNotification = (message, severity = 'success') => {
        setSnackbar({
            open: true,
            message,
            severity
        });
    };

    // Handle close function
    const handleClose = (success = false) => {
        if (success) {
            navigate('/journeybuilder', {
                state: {
                    notification: {
                        message: `Journey ${location.pathname.includes('/calendar-create/') || location.pathname.includes('/calendar-preset/') ? 'created' : 'updated'} successfully`,
                        severity: 'success'
                    }
                }
            });
        } else {
            navigate(-1);
        }
    };

    // Get preset data
    const presetData = location.state?.preset;
    const startDate = location.state?.startDate;

    // Determine mode based on URL
    const isCreateMode = location.pathname.includes('/calendar-create/');
    const isPresetMode = location.pathname.includes('/calendar-preset/');
    const calendarMode = isPresetMode ? 'preset' : (isCreateMode ? 'create' : 'edit');

    return (
        <>
            <ContentDeliveryCalendar
                mode={calendarMode}
                deliveryGroupId={!isCreateMode && !isPresetMode ? deliveryGroupId : undefined}
                onClose={handleClose}
                showNotification={showNotification}
                presetData={presetData}
                startDate={startDate}
            />
            <Snackbar
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert
                    onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
                    severity={snackbar.severity}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </>
    );
};

export default DeliveryCalendarPage;